import React from 'react';

import { TooltipContainer } from './TooltipStyle';

export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
    }

    handleShow = () => {
        const { show } = this.state;
        this.setState({ show: !show });
    };

    render() {
        const { children, text, cssClass, isHover } = this.props;
        const { show } = this.state;

        return (
            <TooltipContainer
                className={`tooltip ${isHover ? 'hover' : ''} ${show ? 'show' : ''} ${
                    cssClass ? cssClass : ''
                }`}
                onClick={this.handleShow}>
                {children}
                <span className="tooltip-text-wrapper">{text}</span>
            </TooltipContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js